module.exports = __webpack_public_path__ + "static/nick-598361379a5167b51d95ceecac5adab3.png";